<template
  :element-loading-text="$locale('global.loading')"
  element-loading-spinner="el-icon-loading"
>
  <div class="page-content ticketSales">
    <h1 class="page-title">{{ $locale("sideMenu.reports.ticketSales") }}</h1>
    <!-- Search Area -->
    <el-row class="search-area">
      <el-col class="makeInline" :lg="16" :md="24" :sm="24">
        <CommDatePickerGroup v-model="filter" v-bind:showWeekly="true" />
      </el-col>
      <el-col class="ta-r" :lg="8" :md="24" :sm="24">
        <el-button @click="exportCsv" class="egl-btn-yellow">{{
          $locale("global.exportToCSV")
        }}</el-button>
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>
    <!-- DeviceSelect -->
    <el-row class="search-area" :gutter="15">
      <el-col :span="1.5">{{
        $locale("cashierReport.dialog.formField.device")
      }}</el-col>
      <el-col :span="4">
        <el-select
          v-model="filter.deviceSecret"
          :placeholder="$locale('accountingReportDownload.dialog.placeholder')"
        >
          <el-option
            v-for="item in deviceList"
            :key="item.id"
            :value="item.deviceSecret"
            :label="item.name"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button class="egl-btn-yellow" @click="search_fn">{{
          $locale("global.confirm2")
        }}</el-button>
      </el-col>
    </el-row>
    <!-- table -->
    <div id="print">
      <div class="table-module">
      <el-row class="tableLabel">
        <el-col :span="3">{{ $locale("sideMenu.reports.ticketSales") }}</el-col>
        <el-col :span="4"
          >{{ $locale("dailyClosing.th.cinemaName") }} :
          {{ tableLabel.cinemaName }}</el-col
        >
        <el-col :span="8"
          >{{ $locale("cashierReport.dialog.formField.device") }} :
          {{ tableLabel.device }}</el-col
        >
        <el-col :span="9" class="ta-r"
          >{{ $locale("trans.report.generatedate") }} :
          {{ tableLabel.createTime }}</el-col
        >
      </el-row>
      <el-row class="tableLabel">
        <el-col :span="6"
          >{{ $locale("business.date") }} : {{ tableLabel.duration }}</el-col
        >
      </el-row>
      <el-table
        class="egl-table payTable"
        :data="tableData"
        border
        :span-method="merge4arrayMethod"
        :cell-class-name="totalName"
        @filter-change="filterHandler"
        @sort-change="sortAmount_fn"
      >
        <el-table-column
          :label="$locale('report.ticketSales.ticketType')"
          prop="name"
          column-key="name"
          :filters="[
            {
              text: $locale('cashierReport.dialog.nationalTicket'),
              value: 'mvtk'
            },
            {
              text: $locale('cashierReport.dialog.advanceCoupon'),
              value: 'advance'
            },
          ]"
          :filtered-value="['mvtk', 'advance']"
        ></el-table-column>
        <el-table-column
          :label="$locale('couponLib.ticketType')"
          prop="ticketType"
          :filters="filterTicketTypes"
          column-key="ticketType"
        ></el-table-column>
        <el-table-column
          :label="$locale('trans.other.price')"
          prop="amount"
          sortable="custom"
          :formatter="priceFormat"
        ></el-table-column>
        <el-table-column
          :label="$locale('global.quantity')"
          prop="qty"
        ></el-table-column>
        <el-table-column
          :label="$locale('accPayMDetail.total')"
          prop="allTotal"
          :formatter="priceFormat"
        ></el-table-column>
      </el-table>
    </div>
    </div>
    
  </div>
</template>
<script>
import CommDatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup";
import { getDeviceList } from "@/helpers/service/api/device.js";
import { ticketSalesList } from "@/helpers/service/api/ticketSales.js";
import { toThousands } from "@/utils/common.js";
import { exportCSV_fn } from "@/assets/js/ticketSales_exportCSV";
export default {
  data() {
    return {
      printObj: {
        popTitle: this.$locale("sideMenu.reports.ticketSales") ,
        id: "print"
      },
      deviceList: [],
      filter: {
        startDate: this.$moment().startOf("day").valueOf(),
        endDate: this.$moment().startOf("day").valueOf(),
        deviceSecret: "",
      },
      tableLabel: {
        cinemaName: "",
        device: "",
        duration: "",
        createTime: "",
      },
      originData: {},
      filterTypes: [],
      filterTicketTypes: [],
      sortType: "",
    };
  },
  created() {
    getDeviceList({ cinemaId: window.localStorage.getItem("cinemaId") }).then(res => {
      this.deviceList = res.data.data;
    });
  },
  computed: {
    tableData() {
      return this.formatTableData();
    }
  },
  methods: {
    exportCsv() {
      if (!this.filter.deviceSecret) {
        this.$alert("デバイスを選択してください");
        return;
      }
      exportCSV_fn({
        startDate: this.$moment(this.filter.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.filter.endDate).format("YYYY-MM-DD"),
        deviceSecret: this.filter.deviceSecret,
        cinemaId: window.localStorage.getItem("cinemaId")
      });
    },
    formatTableData() {
      if (Object.keys(this.originData).length === 0 || (!this.originData.nationalTicket && !this.originData.advanceTicket)) {
        return [];
      }
      let nationalData = [];
      let advanceData = [];
      let nationalData_total = [];
      let advanceData_total = [];
      let allTotal = [];
      const dataMapping = {
        mvtk: {
          name: this.$locale("cashierReport.dialog.nationalTicket"),
          subTotalName: this.$locale("report.ticketSales.mvtkSubTotal"),
          origin: this.originData.nationalTicket,
          data: nationalData,
          subTotal: nationalData_total
        },
        advance: {
          name: this.$locale("cashierReport.dialog.advanceCoupon"),
          subTotalName: this.$locale("report.ticketSales.advanceSubTotal"),
          origin: this.originData.advanceTicket,
          data: advanceData,
          subTotal: advanceData_total,
        },
      };
      if(this.filterTypes.length === 0) {
        const { nationalTicket, advanceTicket } = this.originData;
        // mvtk
        let nationalData = nationalTicket.map(item => ({
          type: "mvtk",
          name: this.$locale("cashierReport.dialog.nationalTicket"),
          ticketType: item.ticketType,
          amount: item.amount,
          qty: item.qty,
          allTotal: item.allTotal,
        }));
        if (nationalData.length > 0) {
          // mvtk subTotal
          nationalData_total = [ {
            name: this.$locale("report.ticketSales.mvtkSubTotal"),
            ticketType: "subTotal",
            amount: "",
            qty: nationalData.reduce((total, item) => total + item.qty, 0),
            allTotal: nationalData.reduce((total, item) => total + item.allTotal, 0),
          } ];
        }
        // advanceTicket
        let advanceData = advanceTicket.map(item => ({
          type: "advance",
          name: this.$locale("cashierReport.dialog.advanceCoupon"),
          ticketType: item.ticketType,
          amount: item.amount,
          qty: item.qty,
          allTotal: item.allTotal,
        }));
        if (advanceData.length > 0) {
          // advance subTotal
          advanceData_total = [ {
            name: this.$locale("report.ticketSales.advanceSubTotal"),
            ticketType: "subTotal",
            amount: "",
            qty: advanceData.reduce((total, item) => total + item.qty, 0),
            allTotal: advanceData.reduce((total, item) => total + item.allTotal, 0),
          } ];
        }
        if (nationalData.length > 0 || advanceData.length > 0) {
          const mvtkQty = nationalData_total.length > 0 ? nationalData_total[0].qty : 0;
          const advanceQty = advanceData_total.length > 0 ? advanceData_total[0].qty : 0;
          const mvtkTotal = nationalData_total.length > 0 ? nationalData_total[0].allTotal : 0;
          const advanceTotal = advanceData_total.length > 0 ? advanceData_total[0].allTotal : 0;
          allTotal = [ {
            name: this.$locale("report.ticketSales.allTotal"),
            ticketType: "allTotal",
            amount: "",
            qty: mvtkQty + advanceQty,
            allTotal:  mvtkTotal + advanceTotal
          } ];
        }
        if (this.sortType) {
          nationalData = this.$_.orderBy(nationalData, [ "amount" ], [ this.sortType === "ascending" ? "asc" : "desc" ]);
          advanceData = this.$_.orderBy(advanceData, [ "amount" ], [ this.sortType === "ascending" ? "asc" : "desc" ]);
        }
        return [...nationalData, ...nationalData_total,
          ...advanceData, ...advanceData_total, ...allTotal];
      }
      const national = dataMapping.mvtk.origin.map(item => ({
        type: "mvtk",
        name: dataMapping.mvtk.name,
        ticketType: item.ticketType,
        amount: item.amount,
        qty: item.qty,
        allTotal: item.allTotal,
      }));
      const advance = dataMapping.advance.origin.map(item => ({
        type: "advance",
        name: dataMapping.advance.name,
        ticketType: item.ticketType,
        amount: item.amount,
        qty: item.qty,
        allTotal: item.allTotal,
      }));
      let _arr = [];
      this.filterTypes.forEach(filter => {
        if (filter === "mvtk" || filter === "advance") {
          dataMapping[filter].data = dataMapping[filter].origin.map(item => ({
            type: filter,
            name: dataMapping[filter].name,
            ticketType: item.ticketType,
            amount: item.amount,
            qty: item.qty,
            allTotal: item.allTotal,
          }));
          if (dataMapping[filter].data.length > 0) {
            dataMapping[filter].subTotal = [ {
              name: dataMapping[filter].subTotalName,
              ticketType: "subTotal",
              amount: "",
              qty: dataMapping[filter].data.reduce((total, item) => total + item.qty, 0),
              allTotal: dataMapping[filter].data.reduce((total, item) => total + item.allTotal, 0),
            } ];
          }
        } else {
          if (national.find(item => item.ticketType === filter)) {
            _arr.push(national.find(item => item.ticketType === filter));

          }
          if (advance.find(item => item.ticketType === filter)) {
            _arr.push(advance.find(item => item.ticketType === filter));
          }
        }
      });
      if (!this.filterTypes.includes("mvtk") && !this.filterTypes.includes("advance")) {
        dataMapping.mvtk.data = _arr.filter(item => item.type === "mvtk");
        if (dataMapping.mvtk.data.length > 0) {
          dataMapping["mvtk"].subTotal = [ {
            name: dataMapping["mvtk"].subTotalName,
            ticketType: "subTotal",
            amount: "",
            qty: dataMapping["mvtk"].data.reduce((total, item) => total + item.qty, 0),
            allTotal: dataMapping["mvtk"].data.reduce((total, item) => total + item.allTotal, 0),
          } ];
        }
        dataMapping.advance.data = _arr.filter(item => item.type === "advance");
        if (dataMapping.advance.data.length > 0) {
          dataMapping["advance"].subTotal = [ {
            name: dataMapping["advance"].subTotalName,
            ticketType: "subTotal",
            amount: "",
            qty: dataMapping["advance"].data.reduce((total, item) => total + item.qty, 0),
            allTotal: dataMapping["advance"].data.reduce((total, item) => total + item.allTotal, 0),
          } ];
        }
      }
      if(dataMapping.mvtk.data.length > 0 || dataMapping.advance.data.length > 0) {
        const mvtkQty = dataMapping["mvtk"].subTotal.length > 0 ? dataMapping["mvtk"].subTotal[0].qty : 0;
        const advanceQty = dataMapping["advance"].subTotal.length > 0 ? dataMapping["advance"].subTotal[0].qty : 0;
        const mvtkTotal = dataMapping["mvtk"].subTotal.length > 0 ? dataMapping["mvtk"].subTotal[0].allTotal : 0;
        const advanceTotal = dataMapping["advance"].subTotal.length > 0 ? dataMapping["advance"].subTotal[0].allTotal : 0;
        allTotal = [ {
          name: this.$locale("report.ticketSales.allTotal"),
          ticketType: "allTotal",
          amount: "",
          qty: mvtkQty + advanceQty,
          allTotal:  mvtkTotal + advanceTotal
        } ];
      }
      if (this.sortType) {
        dataMapping.mvtk.data = this.$_.orderBy(dataMapping.mvtk.data, [ "amount" ], [ this.sortType === "ascending" ? "asc" : "desc" ]);
        dataMapping.advance.data = this.$_.orderBy(dataMapping.advance.data, [ "amount" ], [ this.sortType === "ascending" ? "asc" : "desc" ]);
      }
      return [...dataMapping.mvtk.data, ...dataMapping.mvtk.subTotal, ...dataMapping.advance.data,
        ...dataMapping.advance.subTotal, ...allTotal];
      // return [...dataMapping.mvtk.data, ...dataMapping.mvtk.subTotal, ...dataMapping.advance.data, ...dataMapping.advanceData_total];

    },
    getCount(model, key) {
      let spanArr = [];
      let pos = 0;
      for(let i = 0; i < model.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else if (model[i][key] === model[i - 1][key]) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          pos = i;
        }
      }
      return spanArr;
    },
    mergeComon(key, rowIndex, columnIndex) {
      const _row = this.getCount(this.tableData, key)[rowIndex];
      const _col = _row > 0 ? 1: 0;
      return {
        rowspan: _row,
        colspan: _col
      };
    },
    merge4arrayMethod({ row, column, rowIndex, columnIndex }) {
      if(row.ticketType === "allTotal") {
        if (columnIndex === 0) {
          return [1, 3];
        } else if (columnIndex > 0 && columnIndex < 3) {
          return [0, 0];
        }
      } else if(row.ticketType === "subTotal") {
        if (columnIndex === 0) {
          return [1, 3];
        } else if (columnIndex > 0 && columnIndex < 3) {
          return [0, 0];
        }
      } else {
        switch(columnIndex) {
        case 0:
          return this.mergeComon("name", rowIndex, columnIndex);
        default:
          break;
        }
      }
    },
    search_fn() {
      if (!this.filter.deviceSecret) {
        this.$alert("デバイスを選択してください");
        return;
      }
      ticketSalesList({
        startDate: this.$moment(this.filter.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.filter.endDate).format("YYYY-MM-DD"),
        deviceSecret: this.filter.deviceSecret,
        cinemaId: window.localStorage.getItem("cinemaId")
      }).then(res => {
        const { cinema, reportOf, exportDate } = res.data;
        this.tableLabel = {
          cinemaName: cinema,
          device: this.deviceList.find(item => item.deviceSecret === this.filter.deviceSecret).name,
          createTime: this.$moment(exportDate).format("YYYY-MM-DD (ddd) HH:mm:ss"),
          duration: `${this.$moment(reportOf.start).format("YYYY-MM-DD (ddd)")} ~ ${this.$moment(reportOf.end).format("YYYY-MM-DD (ddd)")}`
        };
        this.originData = res.data;
        this.filterTypes = [];
        this.filterTicketTypes = this.originData.nationalTicket.map(item => ({
          text: item.ticketType,
          value: item.ticketType,
        })).concat(this.originData.advanceTicket.map(item => ({
          text: item.ticketType,
          value: item.ticketType,
        })));
      });
    },
    priceFormat(row, column, cellValue) {
      switch(column.property) {
      case "amount":
        return "¥" + toThousands(cellValue);
      case "allTotal":
        return "¥" + toThousands(cellValue);
      default:
        return cellValue;
      }
    },
    totalName({ row, column, rowIndex, columnIndex }) {
      if (row.ticketType === "subTotal" || row.ticketType === "allTotal") {
        if (columnIndex > 0) {
          return "subTotal-num";
        }
        return "subTotal";
      }
    },
    filterHandler(filters) {
      this.filterTypes = filters.name || filters.ticketType;
    },
    sortAmount_fn(column) {
      this.sortType = column.order;
    }
  },
  components: {
    CommDatePickerGroup,
  },
};
</script>
<style lang="less" scoped>
.tableLabel {
  margin: 18px 0;
}
.table-module ::v-deep {
  .subTotal {
    font-weight: bold;
    text-align: right;
  }
  .subTotal-num {
    font-weight: bold;
  }
}
</style>>